module.exports = __webpack_public_path__ + "static/sui-button-colored-57e08ba75bfb7a2a00bd8357e9101cc7.png";